<template>
  <iframe v-bind:src="url"></iframe>
</template>

<script>
  import { createApp } from 'vue/dist/vue.esm-bundler'
  import VueTypes from 'vue-types'

  export default {
    name: 'PDFViewer',
    props: {
      file: VueTypes.string
    },
    computed: {
      url () {
        const t = new Date().getTime()  // cache buster
        if (this.file.split('?').length === 2) {
          this.file += `&t=${t}`
        } else {
          this.file += `?t=${t}`
        }
        return `/javascripts/pdfjs/web/viewer.html?t=${t}&file=${encodeURIComponent(this.file)}#zoom=page-width`
      }
    }
  }
</script>
